import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
    error: Error | null;
    errorInfo: ErrorInfo | null;
}

class GlobalErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false,
        error: null,
        errorInfo: null
    };

    public static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error, errorInfo: null };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("Uncaught error:", error, errorInfo);
        this.setState({ errorInfo });
    }

    public render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen bg-red-50 flex flex-col items-center justify-center p-6 text-center">
                    <div className="bg-white p-6 rounded-2xl shadow-xl w-full max-w-sm border border-red-200">
                        <i className="ri-error-warning-fill text-5xl text-red-500 mb-4 block"></i>
                        <h1 className="text-xl font-bold text-slate-800 mb-2">Ops! Ocorreu um erro.</h1>
                        <p className="text-slate-500 mb-4 text-sm">O aplicativo encontrou um problema inesperado.</p>

                        <div className="bg-slate-900 text-red-300 p-3 rounded-lg text-left text-xs font-mono overflow-auto max-h-48 mb-6 border border-red-900">
                            {this.state.error && this.state.error.toString()}
                            <br />
                            {this.state.errorInfo && this.state.errorInfo.componentStack.slice(0, 300)}...
                        </div>

                        <button
                            onClick={() => window.location.href = '/'}
                            className="w-full bg-red-600 text-white font-bold py-3 rounded-xl shadow-lg hover:bg-red-700 transition-colors"
                        >
                            Reiniciar App
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default GlobalErrorBoundary;
